import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { CORE_CONFIG_TOKEN } from '@ndk/ng-core/component/core.config';
import { Observable, of as observableOf } from 'rxjs';

import { AuthTokenService } from '@core/authentication/auth-token.service';
import { ICoreConfigInternal } from '@core/core.config.model';

import { ManagerPolicyPermissionTypes } from './settings-manager-permission-policies.enum';
import { IManagerPolicyPermission, IManagerQuotaPermission } from './settings-manager-permissions.model';

@Injectable()
export class SettingsManagerPermissionsService {
    private apiUrl: string;

    constructor(
        @Inject(CORE_CONFIG_TOKEN) config: ICoreConfigInternal, private http: HttpClient,
        private authTokenService: AuthTokenService,
    ) {
        this.apiUrl = `${ config.apiEndpoint }api/settings-users`;
    }

    public getManagerQuotaPermission(): Observable<IManagerQuotaPermission> {
        return this.http.get<IManagerQuotaPermission>(`${ this.apiUrl }/managers/default-quotas-permission`);
    }

    public updateQuotaPermission(command: IManagerQuotaPermission): Observable<boolean> {
        return this.http.post<boolean>(`${ this.apiUrl }/managers/default-quotas-permission`, command);
    }

    public getManagerPolicyPermission(): Observable<IManagerPolicyPermission> {
        if (!this.authTokenService.enabledPoliciesLicense) {
            return observableOf(<IManagerPolicyPermission>{ allowManagement: false, permissionType: ManagerPolicyPermissionTypes.Disabled });
        }

        return this.http.get<IManagerPolicyPermission>(`${ this.apiUrl }/managers/default-policies-permission`);
    }

    public updatePolicyPermission(command: IManagerPolicyPermission): Observable<boolean> {
        return this.http.post<boolean>(`${ this.apiUrl }/managers/default-policies-permission`, command);
    }
}
